import { t } from '@/features/i18n/utils';
import { createFileRoute, Link } from '@tanstack/react-router';
import { api } from '@/api';
import { Logo } from '@/ui/components/logo';
import { Spinner } from '@/ui/components/spinner';

export const Route = createFileRoute('/_authed/go/teams-link/$state')({
  loader: async ({ params }) => {
    const { data } = await api.post<{ linked: boolean }>('v1/integrations/teams/oauth/complete', {
      state: params.state,
    });
    if (!data.linked) throw new Error('Teams identity was not linked');
    return data;
  },
  pendingComponent: () => <Spinner kind="inset" />,
  errorComponent: TeamsLinkError,
  component: TeamsLinkSuccess,
});

function TeamsLinkSuccess() {
  return (
    <div className="px-5 -translate-y-5 w-full">
      <Logo className="mb-5 mx-auto" />
      <h1 className="text-center font-semibold text-lg mb-0.5 lg:text-xl">
        {t({
          en: 'Teams is linked to your Volve account',
          nb: 'Teams er koblet til Volve-kontoen din',
        })}
      </h1>
      <p className="text-center text-muted text-sm">
        {t({
          en: 'You can close this tab and go back to Teams.',
          nb: 'Du kan lukke denne fanen og gå tilbake til Teams.',
        })}
      </p>
    </div>
  );
}

function TeamsLinkError() {
  return (
    <div className="px-5 -translate-y-5 w-full">
      <Logo className="mb-5 mx-auto" />
      <p className="text-center pb-3">
        {t({ en: 'This link is invalid or expired.', nb: 'Denne lenken er ugyldig eller utløpt.' })}
      </p>
      <div className="text-center">
        <Link to="/" className="underline hover:text-foreground text-muted">
          {t({ en: 'Back to homepage', nb: 'Tilbake til hjemmesiden' })}
        </Link>
      </div>
    </div>
  );
}
